
import React, {useState} from "react";
import "./ContactPage.css"
import { Grid, TextField, Button, createTheme, ThemeProvider, InputLabel, FormControl, styled, MenuItem, Select } from '@mui/material';
import { Box } from "@mui/system";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const theme = createTheme({
  status: {
    danger: '#e53e3e',
  },
  palette: {
    primary: {
      main: '#0971f1',
      darker: '#053e85',
    },
    neutral: {
      main: '#64748B',
      contrastText: '#fff',
      grey: '#353535'
    },
    success: {
      main: '#016C34'
    }
  },
  typography: {
    fontFamily: [
      'Space Grotesk',
    ].join(','),
  }
});


const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#016C34',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#016C34',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#c2c2c2',
    },
    '&:hover fieldset': {
      borderColor: '#A5A4A4',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#016C34',
    },
  },
});

const states = [
  'Lagos',
  'Kaduna',
  'Abuja',
];

const ContactUsPage = () => {

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const submitContactForm = () => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    toast.success("Submitted Form Successfully");
  };

  const ToastStyle = {
    backgroundColor: '#016C34',
    color: '#fff',
  };

  const [location, setLocation] = React.useState('');

  const handleChange = (event) => {
    setLocation(event.target.value);
  };

  return (
    <div>
      <div className="contact-main-box">
        <div className="contact-form contact">
          <h1>Contact Us</h1>
          <h4>Feel free to contact us at anytime.</h4>
        <ThemeProvider theme={theme}>
          <Box sx={{ fontFamily: 'Space Grotesk' }}>
            {/* <Typography color="neutral.grey" gutterBottom variant="h3" >Contact Us</Typography>
            <Typography gutterBottom variant="h5" >Feel free to contact us.</Typography> */}
          
              <form>
                <Grid container spacing={3}>

                  <Grid xs={12} item>
                    <CssTextField label="Full Name" placeholder="Last name first" id="custom-css-outlined-input" fullWidth />
                  </Grid>
                  <Grid xs={12} item>
                    <CssTextField label="Email" type={"email"} placeholder="yourname@email.com" id="custom-css-outlined-input" fullWidth />
                  </Grid>
                  <Grid xs={12} item>
                    <CssTextField label="Phone Number" type={"number"} placeholder="Enter phone number" id="custom-css-outlined-input" fullWidth />
                  </Grid>
                  <Grid xs={12} item>
                  
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">Location</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={location}
                        label="Location"
                        onChange={handleChange}
                      >
                        <MenuItem value={states[0]}>Lagos</MenuItem>
                        <MenuItem value={states[1]}>Kaduna</MenuItem>
                        <MenuItem value={states[2]}>Abuja</MenuItem>
                      </Select>
                    </FormControl>

                  </Grid>
                  <Grid xs={12} item>
                    <CssTextField label="Message" multiline rows={4} placeholder="Enter your message here" id="custom-css-outlined-input" fullWidth />
                  </Grid>
                  <Grid xs={12} item>
                  <ThemeProvider theme={theme} >
                    <Button type="submit" variant="contained" color="success" fullWidth onClick={submitContactForm}>Submit</Button>
                  </ThemeProvider>
                  </Grid>
                  
                </Grid>
              </form>
          </Box>
          </ThemeProvider>
        </div>
        
          {/* <iframe
                title="This is a unique title"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5149.27392216835!2d7.4922229639531235!3d9.082812758525252!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104e0a44d3034275%3A0xd1cb83c23f540b76!2sNYSC%20Directorate%20Headquarters%2C%20416%20Tigris%20Cres%2C%20Wuse%20904101%2C%20Abuja!5e0!3m2!1sen!2sng!4v1668086233925!5m2!1sen!2sng"
                width="600"
                height="550"
                frameBorder="0"
                style={{ border: 0 , borderRadius: "10px"}}
                allowFullScreen=""
                aria-hidden="false"
                tabIndex="0"
              /> */}
              <div class="mapouter"><div class="gmap_canvas"><iframe class="gmap_iframe" title="googlemap" width="100%" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=600&amp;height=550&amp;hl=en&amp;q=NYSC Directorate Headquarters, Abuja&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe><a href="https://piratebay-proxys.com/">Piratebay</a></div></div>

      </div>
      <ToastContainer theme="dark" toastStyle={ToastStyle} />
    </div>
  )
}

export default ContactUsPage